// @flow

import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import Spinner from 'app/components/commons/Spinner';

type Props = {
  showOverlay?: boolean,
  children: any,
  classes: Object,
  className?: string,
  inline?: boolean,
};

class FriendsLoader extends React.Component {
  props: Props;

  static defaultProps = {
    showOverlay: false,
    className: '',
    inline: false,
  };

  render() {
    const { classes, showOverlay, children, className, inline } = this.props;

    return (
      <div
        className={classNames(classes.searching, className, {
          overlay: showOverlay,
          inline,
        })}
      >
        <div className={classNames(classes.innerSearch)}>
          <Spinner inlineLeft kind="light" />
          {children}
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    searching: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.color.basis6,
      '&:not(.inline)': {
        minHeight: 100,
      },
      '&.overlay': {
        position: 'absolute',
        maxHeight: 200,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.overlay,
      },
    },
    innerSearch: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      padding: 10,
      borderRadius: 5,
      backgroundColor: theme.color.basis1,
    },
  };
}

export default useSheet(applyStyles)(FriendsLoader);
